import React from "react";

// Simplified: nested ThemeProvider removed to avoid clobbering outer component overrides.
export default function PageContent(props) {
  return <>{props.children}</>;
}
